import { getPersistedInfiniteQueryOptions } from '#pplx/frontend/react-query/internal/getPersistedInfiniteQueryOptions.js';
import { getPersistedQueryOptions } from '#pplx/frontend/react-query/internal/getPersistedQueryOptions.js';
import { useQueryClientProviderConfig } from '#pplx/frontend/react-query/QueryClientProviderContext.js';
import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
/**
 * Uses the query hooks' persistence and error fallback with the existing client.
 * @returns The client and stable option builders. Building options does not start a request.
 */
export function useQueryClientAccess({ queryClient, } = {}) {
    let reactQueryClient = useQueryClient();
    if (queryClient)
        reactQueryClient = queryClient;
    const { allowPersist } = useQueryClientProviderConfig();
    return useMemo(() => ({
        queryClient: reactQueryClient,
        queryOptions: (options) => getPersistedQueryOptions({ options, queryClient: reactQueryClient, allowPersist }),
        infiniteQueryOptions: (options) => getPersistedInfiniteQueryOptions({ options, queryClient: reactQueryClient, allowPersist }),
    }), [allowPersist, reactQueryClient]);
}
//# sourceMappingURL=useQueryClientAccess.js.map